(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // Liquid is not rendered in here and this bundle is shared by every component
  // on the page, so everything these two elements need arrives as `data-*`.

  // The bootstrap cannot itself come from the thing it bootstraps. Four lines,
  // and they are the reason no component has to care which deferred script
  // Shopify ran first.
  function whenThemeReady(callback) {
    if (window.TerraHogar) {
      callback(window.TerraHogar);
      return;
    }
    document.addEventListener('terrahogar:ready', () => callback(window.TerraHogar), { once: true });
  }

  // Every cart surface currently in the document, so one update re-renders all
  // of them in a single request instead of one request each.
  function cartSectionIds() {
    const ids = Array.from(document.querySelectorAll('th-cart-form[data-swap-section]'))
      .map((form) => form.dataset.swapSection)
      .filter(Boolean);
    return Array.from(new Set(ids));
  }

  class ThCartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.cart-drawer__dialog');
      if (!this.dialog) return;

      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.onDocumentClick = this.handleDocumentClick.bind(this);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      if (this.onDocumentClick) document.removeEventListener('click', this.onDocumentClick);
    }

    handleDocumentClick(event) {
      // Lazy lookup, on purpose: with theme.js missing the handler falls
      // through and the browser follows the link to /cart.
      const theme = window.TerraHogar;
      if (!theme) return;
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest && event.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
      // Links inside the drawer are real destinations, not openers.
      if (this.contains(link)) return;

      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (url.pathname !== this.cartUrl) return;

      event.preventDefault();
      theme.dialogs.open(this.dialog);
    }
  }

  class ThCartForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.errorRegion = this.querySelector('[data-cart-error]');
      this.onChange = this.handleChange.bind(this);
      this.onCartUpdated = this.handleCartUpdated.bind(this);
      whenThemeReady((theme) => this.enhance(theme));
    }

    disconnectedCallback() {
      if (this.onCartUpdated) document.removeEventListener('cart:updated', this.onCartUpdated);
    }

    // Nothing is hidden and nothing is intercepted until the shared module is
    // actually present. Until then this is the plain form S10a shipped.
    enhance(theme) {
      if (!this.isConnected || !theme) return;

      // Every unnamed submit is a no-JS fallback — the footer's, plus one
      // beside each quantity field — so one selector hides them all.
      Array.from(this.form.querySelectorAll('button[type="submit"]:not([name])')).forEach(
        (button) => {
          button.hidden = true;
        }
      );

      this.sendUpdates = theme.debounce(() => this.submitUpdates(theme), 300);
      this.form.addEventListener('change', this.onChange);
      document.addEventListener('cart:updated', this.onCartUpdated);
      this.dataset.enhanced = 'true';
    }

    handleChange(event) {
      const field = event.target;
      if (!field || !field.name || field.name.indexOf('updates[') !== 0) return;
      this.sendUpdates();
    }

    // Posts every line, not just the edited one: `updates` is a full statement
    // of the cart, so a stale field elsewhere in the form can never be applied
    // as an edit the shopper did not make.
    submitUpdates(theme) {
      const updates = {};
      Array.from(this.form.querySelectorAll('input[name^="updates["]')).forEach((field) => {
        const key = field.name.slice('updates['.length, -1);
        const quantity = parseInt(field.value, 10);
        updates[key] = Number.isFinite(quantity) && quantity >= 0 ? quantity : 1;
      });

      this.setAttribute('aria-busy', 'true');
      theme.Cart.update(updates, cartSectionIds())
        .catch((error) => this.handleUpdateError(theme, error))
        .finally(() => this.removeAttribute('aria-busy'));
    }

    // A rejected update — most often a quantity above what is in stock —
    // leaves the cart exactly as it was on the server. The field the shopper
    // just edited does not know that, so two things put it right: the
    // store's own message, and a resync of every field against the real
    // cart. `cart:updated` is deliberately not dispatched here — nothing
    // changed, so there is nothing for a fresh render to swap in.
    handleUpdateError(theme, error) {
      this.announceError(error.message);
      this.restoreQuantities(theme);
    }

    announceError(message) {
      if (!this.errorRegion || !message) return;

      this.errorRegion.hidden = false;
      // Same empty-then-fill trick `swap()` uses below: a region that arrives
      // already holding the text is not a change, so most screen readers stay
      // silent.
      this.errorRegion.textContent = '';
      requestAnimationFrame(() => {
        this.errorRegion.textContent = message;
      });
    }

    async restoreQuantities(theme) {
      let cart;
      try {
        cart = await theme.Cart.get();
      } catch (getCartError) {
        // Best-effort: the shopper still has the message from `announceError`
        // even if the fields cannot be resynced this time.
        return;
      }

      const linesByKey = new Map(cart.items.map((item) => [item.key, item]));
      Array.from(this.form.querySelectorAll('input[name^="updates["]')).forEach((field) => {
        const key = field.name.slice('updates['.length, -1);
        const line = linesByKey.get(key);
        if (line) field.value = line.quantity;
      });
    }

    handleCartUpdated(event) {
      const sections = (event.detail && event.detail.sections) || {};
      this.swap(sections[this.dataset.swapSection]);
    }

    swap(html) {
      const selector = this.dataset.swapTarget;
      if (!html || !selector) return;

      const current = this.closest(selector) || document.querySelector(selector);
      if (!current) return;

      const next = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      if (!next) return;

      const active = document.activeElement;
      const focusedId = active && current.contains(active) ? active.id : '';

      current.replaceWith(next);

      // A live region that arrives already populated is not a change, so most
      // screen readers say nothing. Blanking it and restoring its content on
      // the next frame turns the re-render into the update it actually is.
      // The NODES are put back, not `textContent`: both subtotals wrap a label
      // span and an amount span, and restoring plain text flattened them into
      // unstyled "Subtotal $56.930" after every quantity change.
      const status = next.querySelector('[role="status"]');
      if (status) {
        const announcement = Array.from(status.childNodes);
        status.replaceChildren();
        requestAnimationFrame(() => {
          status.replaceChildren(...announcement);
        });
      }

      // The swapped-away field held focus; the new one with the same id is the
      // same control as far as the shopper is concerned.
      if (!focusedId) return;
      const restored = document.getElementById(focusedId);
      if (restored) restored.focus();
    }
  }

  if (!customElements.get('th-cart-drawer')) {
    customElements.define('th-cart-drawer', ThCartDrawer);
  }

  if (!customElements.get('th-cart-form')) {
    customElements.define('th-cart-form', ThCartForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m2-calculator"] && !Shopify.designMode) return;
  try {
    class ThM2Calculator extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.m2-calculator__panel');
      this.areaField = this.querySelector('.m2-calculator__area');
      this.wasteField = this.querySelector('.m2-calculator__waste');
      this.resultField = this.querySelector('.m2-calculator__result');
      this.quantityField = document.getElementById(this.dataset.quantityInput);
      this.m2PerBox = parseFloat(this.dataset.m2PerBox);

      if (!this.panel || !this.areaField || !this.resultField) return;
      if (!this.quantityField || !(this.m2PerBox > 0)) return;

      // Frozen at connect and never refreshed: clearing the area restores the
      // value the field held on page load, NOT a later manual edit.
      this.quantityAtConnect = this.quantityField.value || '1';
      this.panel.hidden = false;
      this.addEventListener('input', this.recalculate);
      this.addEventListener('change', this.recalculate);
    }

    recalculate() {
      const area = parseFloat(String(this.areaField.value).replace(',', '.'));
      const waste = this.wasteField ? parseFloat(this.wasteField.value) : 0;
      const wasteFactor = 1 + (waste > 0 ? waste : 0) / 100;

      if (!(area > 0)) {
        this.resultField.textContent = '';
        this.quantityField.value = this.quantityAtConnect;
        return;
      }

      // Round the quotient before ceiling it. 24 m2 at 10% waste over 1.2 m2 a
      // box is exactly 22, but IEEE754 makes 24 * 1.1 land on 26.400000000000002
      // and the division on 22.000000000000004, which Math.ceil turns into 23 —
      // a whole box of porcelain the customer neither needs nor asked for.
      // Six decimals is far past any tile tolerance and well inside the error.
      const raw = (area * wasteFactor) / this.m2PerBox;
      const boxes = Math.ceil(Math.round(raw * 1e6) / 1e6);
      const covered = boxes * this.m2PerBox;

      this.quantityField.value = String(boxes);
      this.quantityField.dispatchEvent(new Event('change', { bubbles: true }));

      this.resultField.textContent = String(this.dataset.resultTemplate)
        .replace('%BOXES%', this.formatNumber(boxes))
        .replace('%AREA%', this.formatNumber(covered));
    }

    formatNumber(value) {
      const rounded = Math.round(value * 100) / 100;
      return String(rounded).replace('.', this.dataset.decimalSeparator || '.');
    }
  }

  if (!customElements.get('th-m2-calculator')) {
    customElements.define('th-m2-calculator', ThM2Calculator);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    // Liquid is not rendered in here. Routes, the section id and every translated
  // string arrive through `data-*` or through the HTML the section renders.
  function whenThemeReadyForSearch(callback) {
    if (window.TerraHogar) {
      callback(window.TerraHogar);
      return;
    }
    document.addEventListener('terrahogar:ready', () => callback(window.TerraHogar), { once: true });
  }

  const PREDICTIVE_PANEL_SELECTOR = '.predictive-search__panel';
  const PREDICTIVE_OPTION_SELECTOR = '[role="option"]';

  class ThPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector(PREDICTIVE_PANEL_SELECTOR);
      this.status = this.querySelector('[data-predictive-search-status]');
      this.dialog = this.parentElement
        ? this.parentElement.querySelector('.predictive-search__dialog')
        : null;
      if (!this.input || !this.panel) return;

      this.activeIndex = -1;
      this.controller = null;

      this.onDocumentClick = this.handleDocumentClick.bind(this);
      document.addEventListener('click', this.onDocumentClick);

      whenThemeReadyForSearch((theme) => this.enhance(theme));
    }

    disconnectedCallback() {
      if (this.onDocumentClick) document.removeEventListener('click', this.onDocumentClick);
    }

    // Everything that would lie to a screen reader without a script is applied
    // here and nowhere else.
    enhance(theme) {
      if (!this.isConnected || !theme) return;

      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('aria-haspopup', 'listbox');

      this.request = theme.debounce(() => this.fetchResults(), 250);
      this.input.addEventListener('input', this.request);
      this.input.addEventListener('keydown', (event) => this.handleKeydown(event));
      this.input.addEventListener('focus', () => {
        if (this.panel.querySelector(PREDICTIVE_OPTION_SELECTOR)) this.open();
      });

      // The header's toggle and the inline form are two answers to the same
      // question, so the toggle only appears once the dialog can actually open.
      document.querySelectorAll('[data-search-dialog-open]').forEach((toggle) => {
        toggle.hidden = false;
      });
      this.dataset.dialogEnhanced = 'true';
    }

    handleDocumentClick(event) {
      const theme = window.TerraHogar;
      const target = event.target;
      if (!target || !target.closest) return;

      const toggle = target.closest('[data-search-dialog-open]');
      if (toggle) {
        // Lazy lookup: with theme.js missing this falls through and the toggle,
        // which is still `hidden`, was never reachable in the first place.
        if (!theme || !this.dialog) return;
        event.preventDefault();
        theme.dialogs.open(this.dialog);

        // The shared helper focuses the first focusable node, which is the
        // close control. A search dialog a shopper has just asked for should
        // land them in the field, not on the way out of it.
        const field = this.dialog.querySelector('input[type="search"]');
        if (field) field.focus();
        return;
      }

      if (!this.contains(target)) this.close();
    }

    async fetchResults() {
      const terms = this.input.value.trim();
      if (terms.length < 2) {
        this.close();
        return;
      }

      // One flight at a time: a slow answer for "rob" must never land on top of
      // a fast one for "roble".
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      const url = new URL(this.dataset.suggestUrl || '/search/suggest', window.location.href);
      url.searchParams.set('q', terms);
      url.searchParams.set('resources[type]', 'product,article,page');
      url.searchParams.set('resources[limit]', '4');
      url.searchParams.set('section_id', this.dataset.sectionId || 'predictive-search');

      try {
        const response = await fetch(url.toString(), { signal: this.controller.signal });
        if (!response.ok) throw new Error('Predictive search failed');
        this.swap(await response.text());
      } catch (error) {
        if (error.name === 'AbortError') return;
        // The form underneath is a real GET to /search, so the shopper's next
        // move is the one that was always available.
        this.close();
      }
    }

    swap(html) {
      const next = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(PREDICTIVE_PANEL_SELECTOR);
      if (!next) return;

      this.panel.replaceWith(next);
      this.panel = next;
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.open();
      this.announce();
    }

    // The sentence was written by Liquid and translated by `t`; this only moves
    // it into the live region that is not inside the panel.
    announce() {
      if (!this.status) return;
      const source = this.panel.querySelector('[data-predictive-search-announcement]');
      const text = source ? source.textContent.trim() : '';

      this.status.textContent = '';
      requestAnimationFrame(() => {
        this.status.textContent = text;
      });
    }

    options() {
      return Array.from(this.panel.querySelectorAll(PREDICTIVE_OPTION_SELECTOR));
    }

    // The panel and the listbox are not the same thing. On zero results the
    // panel still shows, carrying the "no encontramos resultados" sentence, but
    // there is no listbox inside it — so aria-expanded stays false and
    // aria-controls names nothing. Claiming an expanded popup that holds no
    // options tells a screen reader there is something to arrow into.
    listbox() {
      return this.panel.querySelector('[role="listbox"]');
    }

    open() {
      this.panel.hidden = false;
      const listbox = this.listbox();
      if (listbox) {
        this.input.setAttribute('aria-controls', listbox.id);
        this.input.setAttribute('aria-expanded', 'true');
      } else {
        this.input.removeAttribute('aria-controls');
        this.input.setAttribute('aria-expanded', 'false');
      }
    }

    close() {
      this.panel.hidden = true;
      this.input.removeAttribute('aria-controls');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.activeIndex = -1;
      this.options().forEach((option) => option.removeAttribute('aria-selected'));
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }

      const options = this.options();
      if (options.length === 0 || this.panel.hidden) return;

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;

        // With nothing selected the cursor sits BEFORE the first option, not at
        // index -1 in the ring: ArrowUp from there has to land on the last
        // option. Executed in node against a three-option list, the naive
        // `-1 + -1` wrapped to index 1 — the middle of the list, which is
        // neither end and reads as a random jump.
        const from = this.activeIndex < 0 && step === -1 ? 0 : this.activeIndex;
        const next = from + step;

        // Wraps at both ends, so the list is a ring rather than a dead stop.
        this.activate(((next % options.length) + options.length) % options.length);
        return;
      }

      if (event.key === 'Enter' && this.activeIndex > -1) {
        event.preventDefault();
        options[this.activeIndex].click();
      }
    }

    activate(index) {
      const options = this.options();
      options.forEach((option) => option.removeAttribute('aria-selected'));

      this.activeIndex = index;
      const active = options[index];
      if (!active) return;

      active.setAttribute('aria-selected', 'true');
      this.input.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({ block: 'nearest' });
    }
  }

  if (!customElements.get('th-predictive-search')) {
    customElements.define('th-predictive-search', ThPredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ThProductGallery extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.product-gallery__stage');
      if (!this.stage) return;

      this.onThumbClick = this.handleThumbClick.bind(this);
      this.addEventListener('click', this.onThumbClick);
    }

    disconnectedCallback() {
      if (this.onThumbClick) this.removeEventListener('click', this.onThumbClick);
    }

    handleThumbClick(event) {
      const thumb = event.target.closest && event.target.closest('.product-gallery__thumb');
      if (!thumb || !this.contains(thumb)) return;
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const targetId = (thumb.getAttribute('href') || '').slice(1);
      const slide = targetId ? document.getElementById(targetId) : null;
      // Only a slide inside THIS gallery; anything else falls through to the
      // browser's own anchor handling.
      if (!slide || !this.stage.contains(slide)) return;

      event.preventDefault();

      // Measured from the rendered boxes rather than offsetLeft: the stage is
      // not a positioned element, so offsetLeft would be relative to some
      // ancestor further up and land on the wrong slide.
      const left =
        slide.getBoundingClientRect().left -
        this.stage.getBoundingClientRect().left +
        this.stage.scrollLeft;

      // No `behavior`: the stage's CSS scroll-behavior decides, which is how the
      // reduced-motion rule keeps working.
      this.stage.scrollTo({ left });
    }
  }

  if (!customElements.get('th-product-gallery')) {
    customElements.define('th-product-gallery', ThProductGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    class ThVariantPicker extends HTMLElement {
    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll('.variant-picker__input'));
      this.chips = Array.from(this.querySelectorAll('.variant-picker__chip'));
      if (this.inputs.length !== this.chips.length || this.inputs.length === 0) return;

      this.inputs.forEach((input, index) => {
        input.removeAttribute('tabindex');
        input.removeAttribute('aria-hidden');
        input.setAttribute('aria-label', this.chips[index].textContent.trim());
      });
      this.chips.forEach((chip) => {
        chip.setAttribute('tabindex', '-1');
      });

      this.dataset.enhanced = 'true';
      this.addEventListener('change', this.navigateToVariant);
    }

    navigateToVariant(event) {
      const index = this.inputs.indexOf(event.target);
      const chip = this.chips[index];
      if (!chip) return;
      this.setAttribute('aria-busy', 'true');
      window.location.assign(chip.href);
    }
  }

  if (!customElements.get('th-variant-picker')) {
    customElements.define('th-variant-picker', ThVariantPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
